<!-- 予約状況確認画面 -->
<style src="@/assets/css/admin_parts.css" type="text/css" media="all" scoped></style>

<template>
	<!-- ▽  -->
	<div class="contents" id="adminRSC">
		<!-- ▽ -->
		<section id="mainContent">
			<h2>状況確認</h2>
			<section class="status">
				<section class="outStanding">
					<h3>未処理状況</h3>
					<!-- 未処理状況欄 START -->
					<table>
						<caption>未処理人数</caption>
						<tbody>
						<tr><th>新規</th><td>{{outStanding.countNew}}</td></tr>
						<tr><th>変更</th><td>{{outStanding.countChange}}</td></tr>
						<tr><th>キャンセル</th><td>{{outStanding.countCancel}}</td></tr>
						</tbody>
					</table>
					<!-- 未処理状況欄 END -->
				</section>
				<section class="inputArea">
					<h3>予約状況</h3>
					<table class="inputTbl">
						<tbody>
						<tr>
							<th>予約登録日</th>
							<td class="dayForm">
								<ul>
									<li>
										<select v-model="reserveStatus.inputForm.crdyStYear">
											<option value=0>未選択</option>
											<option v-for="item in reserveStatus.inputForm.listYear" v-bind:key="item">
												{{item}}
											</option>
										</select>
									</li>
									<li>
										<select v-model="reserveStatus.inputForm.crdyStMonth">
											<option value=0>未選択</option>
											<option v-for="item in reserveStatus.inputForm.listMonth" v-bind:key="item">
												{{item}}
											</option>
										</select>
									</li>
									<li>
										<select v-model="reserveStatus.inputForm.crdyStDate">
											<option value=0>未選択</option>
											<option v-for="item in computedListCrdyStDate" v-bind:key="item">
												{{item}}
											</option>
										</select>
									</li>
									</ul>
									<ul>
									 <li>
										<select v-model="reserveStatus.inputForm.crdyEdYear">
											<option value=0>未選択</option>
											<option v-for="item in reserveStatus.inputForm.listYear" v-bind:key="item">
												{{item}}
											</option>
										</select>
									</li>
									<li>
										<select v-model="reserveStatus.inputForm.crdyEdMonth">
											<option value=0>未選択</option>
											<option v-for="item in reserveStatus.inputForm.listMonth" v-bind:key="item">
												{{item}}
											</option>
										</select>
									</li>
									<li>
										<select v-model="reserveStatus.inputForm.crdyEdDate">
											<option value=0>未選択</option>
											<option v-for="item in computedListCrdyEdDate" v-bind:key="item">
												{{item}}
											</option>
										</select>
									</li>
								</ul>
							</td>
						</tr>
						<tr>
							<th>予約更新日</th>
							<td class="dayForm">
								<ul>
									<li>
								<select v-model="reserveStatus.inputForm.updyStYear">
									<option value=0>未選択</option>
									<option v-for="item in reserveStatus.inputForm.listYear" v-bind:key="item">
										{{item}}
									</option>
								</select>
									</li>
									<li>
								<select v-model="reserveStatus.inputForm.updyStMonth">
									<option value=0>未選択</option>
									<option v-for="item in reserveStatus.inputForm.listMonth" v-bind:key="item">
										{{item}}
									</option>
								</select>
									</li>
									<li>
								<select v-model="reserveStatus.inputForm.updyStDate">
									<option value=0>未選択</option>
									<option v-for="item in computedListUpdyStDate" v-bind:key="item">
										{{item}}
									</option>
								</select>
									</li>
									</ul>
									<ul>
									<li>
								<select v-model="reserveStatus.inputForm.updyEdYear">
									<option value=0>未選択</option>
									<option v-for="item in reserveStatus.inputForm.listYear" v-bind:key="item">
										{{item}}
									</option>
								</select>
									</li>
									<li>
								<select v-model="reserveStatus.inputForm.updyEdMonth">
									<option value=0>未選択</option>
									<option v-for="item in reserveStatus.inputForm.listMonth" v-bind:key="item">
										{{item}}
									</option>
								</select>
									</li>
									<li>
								<select v-model="reserveStatus.inputForm.updyEdDate">
									<option value=0>未選択</option>
									<option v-for="item in computedListUpdyEdDate" v-bind:key="item">
										{{item}}
									</option>
								</select>
									</li>
									</ul>
							</td>
						</tr>
						<tr>
							<th>受診日</th>
							<td class="dayForm">
								<ul>
									<li>
								<select v-model="reserveStatus.inputForm.ykdyStYear">
									<option value=0>未選択</option>
									<option v-for="item in reserveStatus.inputForm.listYear" v-bind:key="item">
										{{item}}
									</option>
								</select>
									</li>
									<li>
								<select v-model="reserveStatus.inputForm.ykdyStMonth">
									<option value=0>未選択</option>
									<option v-for="item in reserveStatus.inputForm.listMonth" v-bind:key="item">
										{{item}}
									</option>
								</select>
									</li>
									<li>
								<select v-model="reserveStatus.inputForm.ykdyStDate">
									<option value=0>未選択</option>
									<option v-for="item in computedListYkdyStDate" v-bind:key="item">
										{{item}}
									</option>
								</select>
									</li>
									</ul>
									<ul>
									<li>
								<select v-model="reserveStatus.inputForm.ykdyEdYear">
									<option value=0>未選択</option>
									<option v-for="item in reserveStatus.inputForm.listYear" v-bind:key="item">
										{{item}}
									</option>
								</select>
									</li>
									<li>
								<select v-model="reserveStatus.inputForm.ykdyEdMonth">
									<option value=0>未選択</option>
									<option v-for="item in reserveStatus.inputForm.listMonth" v-bind:key="item">
										{{item}}
									</option>
								</select>
									</li>
									<li>
								<select v-model="reserveStatus.inputForm.ykdyEdDate">
									<option value=0>未選択</option>
									<option v-for="item in computedListYkdyEdDate" v-bind:key="item">
										{{item}}
									</option>
								</select>
									</li>
									</ul>
							</td>
						</tr>
						</tbody>
					</table>
				</section>
			</section>
			<!-- ▽ 抽出結果 -->
			<section class="outputArea">
				<div class="btnLst">
					<button class="onSearch" v-on:click="onSearch">抽出</button>
				</div>
				<!-- 予約状況欄 START -->
				<div class="reserveStatus">
					<dl v-for="item in reserveStatus.listResultCountOfWaku" v-bind:key="item.wknm">
						<dt>{{item.wknm}}</dt><dd>{{item.count}}</dd>
					</dl>
				</div>
				<!-- 予約状況欄 END -->
				<!-- 月毎予約状況 START -->
				<table class="calendarTbl">
					<caption>
					<div class="listUp">
						<select v-model="reserveStatusOfMonth.currentWaku" v-on:change="onChangeListWaku">
							<option v-for="(item,index) in reserveStatusOfMonth.listWaku" v-bind:key="item.waku" v-bind:id="getBindName('wakuRadio',index)" v-bind:value="item.waku">
								{{item.wknm}}
							</option>
						</select>
						<select v-model="reserveStatusOfMonth.currentShukeiShubetsu" v-on:change="onChangeListShukeiShubetsu">
							<option v-for="item in computedShukeiShubetsu" v-bind:key="item.shubetsu" v-bind:value="item.shubetsu">
								{{item.value}}
							</option>
						</select>
						<ul class="controller">
							<li><span v-if="reserveStatusOfMonth.calender.flagPreMonth" v-on:click="onCalenderPreMonth()">前の月</span></li>
							<li>{{reserveStatusOfMonth.calender.year}}年{{reserveStatusOfMonth.calender.month}}月</li>
							<li><span v-if="reserveStatusOfMonth.calender.flagNextMonth" v-on:click="onCalenderNextMonth()">次の月</span></li>
						</ul>
					</div>
					<p class="total"><span>月合計人数</span><b>{{computedSumOfCountMonth}}</b></p>
					</caption>
					<thead>
					<!-- 曜日の表示 -->
						<tr>
							<td v-for="week in reserveStatusOfMonth.calender.weekdays" v-bind:key="week">{{week}}</td>
						</tr>
					</thead>
					<tbody>
					<!-- 日付、予約状況の表示 -->
					<tr v-for="i in reserveStatusOfMonth.calender.displayDatesWeekIndexes" v-bind:key="i">
						<td v-for="j in reserveStatusOfMonth.calender.displayDatesDayIndexes" v-bind:key="j">
							<dl>
								<dt>{{reserveStatusOfMonth.calender.displayDates[i * 7 + j]}}</dt>
								<dd v-if="reserveStatusOfMonth.calender.isCuliculate" v-show="reserveStatusOfMonth.calender.reserveData[i * 7 + j].isDisplay">
									<div class="total" v-if="getCurrentKrkb() == '1'">
										<b>{{reserveStatusOfMonth.calender.reserveData[i * 7 + j].sumCountOfDate}}</b>
									</div>
									<div class="aggre" v-else-if="getCurrentKrkb() == '2'">
										<ul>
											<li><span>合計</span><b>{{reserveStatusOfMonth.calender.reserveData[i * 7 + j].sumCountOfDate}}</b></li>
											<li v-for="item in reserveStatusOfMonth.calender.reserveData[i * 7 + j].countArray" v-bind:key="item.sthm">
												<span>{{item.sthm}}</span><b>{{item.sumCount}}</b>
											</li>
										</ul>
									</div>
								</dd>
							</dl>
						</td>
					</tr>
					</tbody>
				</table>
				<!-- 月毎予約状況 END -->
			</section>
		</section>
		<!-- △ mainContents END -->
		<!-- モーダルWindow S -->
		<modalWindow v-show="modal.validationError.isShow" v-on:close="onValidationErrorModalClose">
			<dt slot="modal-header">入力エラー</dt>
			<dd slot="modal-body">
				<errorMessageBox :errorMessages="modal.validationError.messages"></errorMessageBox>
			</dd>
			<dd slot="modal-footer"><a href="javascript:void(0)" v-on:click="onValidationErrorModalClose">閉じる</a></dd>
		</modalWindow>
		<!-- モーダルWindow E -->
		<!-- モーダルWindow S -->
		<modalWindow v-show="modal.masterError.isShow" v-on:close="onMasterErrorModalClose">
			<dt slot="modal-header">マスタエラー</dt>
			<dd slot="modal-body">
				<errorMessageBox :errorMessages="modal.masterError.messages"></errorMessageBox>
			</dd>
			<dd slot="modal-footer"><a href="javascript:void(0)" v-on:click="onMasterErrorModalClose">閉じる</a></dd>
		</modalWindow>
		<!-- モーダルWindow E -->
		<!-- モーダルWindow S -->
		<modalWindow v-show="modal.systemError.isShow" v-on:close="onSystemErrorModalClose">
			<dt slot="modal-header">システムエラー</dt>
			<dd slot="modal-body">
				<errorMessageBox :errorMessages="modal.systemError.messages"></errorMessageBox>
			</dd>
			<dd slot="modal-footer"><a href="javascript:void(0)" v-on:click="onSystemErrorModalClose">閉じる</a></dd>
		</modalWindow>
		<!-- モーダルWindow E -->
	</div>
</template>
<script>
	import { AdminReserveStatusCheck } from '@/api'
	import * as ErrorCodes from '@/components/Utility/error-codes'
	import ErrorMessageBox from '@/components/Utility/ErrorMessageBox'
	import ModalWindow from '@/components/Utility/ModalWindow'
	import * as UtilityConsoleLog from '@/components/Utility/UtilityConsoleLog'

	export default {
		name: 'AdminReserveStatusCheck',
		components: {
			// エラー表示コンポーネント
			errorMessageBox: ErrorMessageBox,
			// モーダルウィンドウ表示コンポーネント
			modalWindow: ModalWindow
		},
		// 算出プロパティ
		computed: {
			// 予約登録日　開始日　日付のプルダウン内容を生成
			computedListCrdyStDate: function () {

				var tempListDate = []

				// 当月の最終日の求め方
				// 本来8月なら第二引数（月）は7を与えるべきだが
				// 本来8月なら第三引数（日）に0を与えて
				// 次月の最初の日（1日）より一日前（0日）で
				// 当月の最終日を求める
				var lastDate = new Date(
					this.reserveStatus.inputForm.crdyStYear,
					this.reserveStatus.inputForm.crdyStMonth, 0).getDate()

				for (var i = 1; i <= lastDate; i++) {
					tempListDate.push(i)
				}

				return tempListDate
			},
			// 予約登録日　終了日　日付のプルダウン内容を生成
			computedListCrdyEdDate: function () {

				var tempListDate = []

				// 当月の最終日の求め方
				// 本来8月なら第二引数（月）は7を与えるべきだが
				// 本来8月なら第三引数（日）に0を与えて
				// 次月の最初の日（1日）より一日前（0日）で
				// 当月の最終日を求める
				var lastDate = new Date(
					this.reserveStatus.inputForm.crdyEdYear,
					this.reserveStatus.inputForm.crdyEdMonth, 0).getDate()

				for (var i = 1; i <= lastDate; i++) {
					tempListDate.push(i)
				}

				return tempListDate
			},
			// 予約更新日　開始日　日付のプルダウン内容を生成
			computedListUpdyStDate: function () {

				var tempListDate = []

				// 当月の最終日の求め方
				// 本来8月なら第二引数（月）は7を与えるべきだが
				// 本来8月なら第三引数（日）に0を与えて
				// 次月の最初の日（1日）より一日前（0日）で
				// 当月の最終日を求める
				var lastDate = new Date(
					this.reserveStatus.inputForm.updyStYear,
					this.reserveStatus.inputForm.updyStMonth, 0).getDate()

				for (var i = 1; i <= lastDate; i++) {
					tempListDate.push(i)
				}

				return tempListDate
			},
			// 予約更新日　終了日　日付のプルダウン内容を生成
			computedListUpdyEdDate: function () {

				var tempListDate = []

				// 当月の最終日の求め方
				// 本来8月なら第二引数（月）は7を与えるべきだが
				// 本来8月なら第三引数（日）に0を与えて
				// 次月の最初の日（1日）より一日前（0日）で
				// 当月の最終日を求める
				var lastDate = new Date(
					this.reserveStatus.inputForm.updyEdYear,
					this.reserveStatus.inputForm.updyEdMonth, 0).getDate()

				for (var i = 1; i <= lastDate; i++) {
					tempListDate.push(i)
				}

				return tempListDate
			},
			// 受診日　開始日　日付のプルダウン内容を生成
			computedListYkdyStDate: function () {

				var tempListDate = []

				// 当月の最終日の求め方
				// 本来8月なら第二引数（月）は7を与えるべきだが
				// 本来8月なら第三引数（日）に0を与えて
				// 次月の最初の日（1日）より一日前（0日）で
				// 当月の最終日を求める
				var lastDate = new Date(
					this.reserveStatus.inputForm.ykdyStYear,
					this.reserveStatus.inputForm.ykdyStMonth, 0).getDate()

				for (var i = 1; i <= lastDate; i++) {
					tempListDate.push(i)
				}

				return tempListDate
			},
			// 受診日　終了日　日付のプルダウン内容を生成
			computedListYkdyEdDate: function () {

				var tempListDate = []

				// 当月の最終日の求め方
				// 本来8月なら第二引数（月）は7を与えるべきだが
				// 本来8月なら第三引数（日）に0を与えて
				// 次月の最初の日（1日）より一日前（0日）で
				// 当月の最終日を求める
				var lastDate = new Date(
					this.reserveStatus.inputForm.ykdyEdYear,
					this.reserveStatus.inputForm.ykdyEdMonth, 0).getDate()

				for (var i = 1; i <= lastDate; i++) {
					tempListDate.push(i)
				}

				return tempListDate
			},
			// 月合計人数を算出
			computedSumOfCountMonth: function() {

				var sumOfCountMonth = 0

				// カレンダー表示日毎の一日の合計人数を集計
				// 時間帯枠、日枠のどちらでも同じ集計方法で行う
				// this.reserveStatusOfMonth.calender.reserveData[i].sumCountOfDate

				for(var i=0;i<this.reserveStatusOfMonth.calender.reserveData.length;i++){
					sumOfCountMonth += this.reserveStatusOfMonth.calender.reserveData[i].sumCountOfDate
				}

				return sumOfCountMonth
			},
			// 集計結果種別リスト
			computedShukeiShubetsu: function () {

				var resultList = []

				if('0000' == this.reserveStatusOfMonth.currentWaku) {
					this.reserveStatusOfMonth.currentShukeiShubetsu = '0'
				  resultList = this.reserveStatusOfMonth.listShukeiShubetsu.filter((item) => {
				  	return item.shubetsu == '0'
				  })
				} else {
					resultList = this.reserveStatusOfMonth.listShukeiShubetsu
				}
				
				return resultList
			}
		},
		// データ
		data() {
			return {
				// 出力データ
				// 未処理人数欄
				outStanding: {
					// 新規
					countNew: 0,
					// 変更
					countChange: 0,
					// キャンセル
					countCancel: 0
				},

				// 予約状況欄
				reserveStatus: {

					// 入力フォーム
					inputForm: {
						// 年のプルダウン内容
						listYear: [],
						// 月のプルダウン内容
						listMonth: [
							1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12
						],
						// 予約登録日　開始日
						crdyStYear: 0,
						crdyStMonth: 0,
						crdyStDate: 0,
						// 予約登録日　終了日
						crdyEdYear: 0,
						crdyEdMonth: 0,
						crdyEdDate: 0,
						// 予約更新日　開始日
						updyStYear: 0,
						updyStMonth: 0,
						updyStDate: 0,
						// 予約更新日　終了日
						updyEdYear: 0,
						updyEdMonth: 0,
						updyEdDate: 0,
						// 受診日　開始日
						ykdyStYear: 0,
						ykdyStMonth: 0,
						ykdyStDate: 0,
						// 受診日　終了日
						ykdyEdYear: 0,
						ykdyEdMonth: 0,
						ykdyEdDate: 0
					},

					// 予約状況（枠ごとの集計結果）
					// wknm: 予約枠名
					// count: 集計結果
					listResultCountOfWaku: [],
				},

				// 月毎予約状況欄
				reserveStatusOfMonth: {

					// 医療機関に紐づく枠リスト
					// waku: 予約枠
					// wknm: 予約枠名
					// krkb: 枠管理区分
					listWaku: [],
					// どの枠を指定しているか
					currentWaku: '0000',

          // 集計結果種別リスト
					// '0': 登録人数の集計結果
					// '1': 枠の集計結果
          listShukeiShubetsu: [
						{
							shubetsu: '0',
							value: '登録人数の集計結果'
						},
						{
							shubetsu: '1',
							value: '枠の集計結果'
						}
					],
					// どの集計結果種別を指定しているか
					currentShukeiShubetsu: '0',

					// 休業日マスタの最小日付と最大日付
					calmDate: {
						// 最小日付　年
						minDateYear: 0,
						// 最小日付　月
						minDateMonth: 0,
						// 最小日付　日付
						minDateDate: 0,
						// 最大日付　年
						maxDateYear: 0,
						// 最大日付　月
						maxDateMonth: 0,
						// 最大日付　日付
						maxDateDate: 0
					},
					// 現在時刻
					currentDateTime: {
						// 年
						YYYY: 0,
						// 月
						MM: 0,
						// 日
						DD: 0,
						// 時間
						hh: 0,
						// 分
						mm: 0
					},

					// 現在のカレンダー表示に必要なデータ
					calender: {
						// '日' ～ '土'
						weekdays: ['日', '月', '火', '水', '木', '金', '土'],
						// 表示するカレンダーの年
						year: 0,
						// 表示するカレンダーの月
						month: 0,
						// 前の月、次の月リンクの表示非表示
						// true:表示
						// false:非表示
						flagPreMonth: true,
						flagNextMonth: true,
						// 表示するカレンダーの末尾日付
						monthLastDate: 0,
						// 表示するカレンダーの月の初日の曜日
						firstDayOfWeek: 0,
						// 表示するカレンダーの月の末日の曜日
						lastDayOfWeek: 0,
						// 前月の第５週の表示日（初週に表示）
						preMonthDates: [],
						// 次月の第１週の表示日（初週に表示）
						nextMonthDates: [],
						// カレンダーに表示する日付配列
						displayDates: [],
						// カレンダーに表示する日付配列の行
						// （何週持ってるか）の添え字配列を作成
						displayDatesWeekIndexes: [],
						// カレンダーに表示する日付配列の列
						displayDatesDayIndexes: [0, 1, 2, 3, 4, 5, 6],
						// 計算終わったかどうか
						isCuliculate: false,
						// カレンダー表示用に整形された予約結果配列
						reserveData: [
							{
								isDisplay: false,
								sumCountOfDate: 0,
								countArray: [
									{
										sthm: '',
										sumCount: 0
									}
								]
							}
						],
					},
					// 予約データ 全て
					// reserveDate: 予約日
					// sthm: 表示開始時間
					// sumCount: 人数（その日の既予約人数）
					listReserveDateWakuAll: [],
					
					// 予約データ　枠ごと１
					// （枠管理区分：日）
					// 登録人数の集計結果
					// waku: 予約枠
					// reserveDate: 予約日
					// sumCount: 人数
					listReserveDate1: [],

					// 予約データ　枠ごと２
					// （枠管理区分：時間帯）
					// 登録人数の集計結果
					// waku: 予約枠
					// reserveDate: 予約日
					// sthm: 表示開始時間
					// sumCount: 人数
					listReserveDate2: [],

					// 予約データ　枠ごと１
					// （枠管理区分：日）
					// 枠の集計結果
					// waku: 予約枠
					// reserveDate: 予約日
					// sumCount: 人数
					listReserveDate3: [],

					// 予約データ　枠ごと２
					// （枠管理区分：時間帯）
					// 枠の集計結果
					// waku: 予約枠
					// reserveDate: 予約日
					// sthm: 表示開始時間
					// sumCount: 人数
					listReserveDate4: [],
				},

				// モーダルウィンドウ
				modal: {
					validationError: {
						messages: [],
						isShow: false
					},
					masterError: {
						messages: [],
						isShow: false
					},
					systemError: {
						messages: [
							'システムエラーです。',
							'内容をもう一度ご確認ください。'
						],
						isShow: false
					}
				}
			}
		},
		// ライフサイクルフック: created
		created: function () {
			UtilityConsoleLog.consoleLog('AdminReserveStatusCheck::created Start')

			this.firstDisplay()

			UtilityConsoleLog.consoleLog('AdminReserveStatusCheck::created End')
		},
		methods: {
			// 表示系--------------------------------------------------S
			// 初期表示
			firstDisplay: function () {
				UtilityConsoleLog.consoleLog('AdminReserveStatusCheck::firstDisplay Start')

				AdminReserveStatusCheck.FirstDisplay({
					token: this.$store.state.auth.token,
					ircd: this.$store.state.auth.ircd,
				}).then(({responce}) => {

					if (responce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {
						
						// 未処理人数欄
						// 新規
						this.outStanding.countNew = responce.data.outStandingResultCountNew
						// 変更
						this.outStanding.countChange = responce.data.outStandingResultCountChange
						// キャンセル
						this.outStanding.countCancel = responce.data.outStandingResultCountCancel

						// 予約状況欄
						// 年のプルダウン内容
						this.reserveStatus.inputForm.listYear = responce.data.listYear

						// 予約状況（枠ごとの集計結果）
						this.reserveStatus.listResultCountOfWaku = responce.data.listResultCountOfWaku

						// 月毎予約状況欄
						// 医療機関に紐づく枠
						this.reserveStatusOfMonth.listWaku = responce.data.listWaku
						//休業日マスタの最小日付と最大日付
						this.reserveStatusOfMonth.calmDate.minDateYear = responce.data.calmDate.minDateYear
						this.reserveStatusOfMonth.calmDate.minDateMonth = responce.data.calmDate.minDateMonth
						this.reserveStatusOfMonth.calmDate.minDateDate = responce.data.calmDate.minDateDate
						this.reserveStatusOfMonth.calmDate.maxDateYear = responce.data.calmDate.maxDateYear
						this.reserveStatusOfMonth.calmDate.maxDateMonth = responce.data.calmDate.maxDateMonth
						this.reserveStatusOfMonth.calmDate.maxDateDate = responce.data.calmDate.maxDateDate
						// 現在時刻
						this.reserveStatusOfMonth.currentDateTime.YYYY = responce.data.currentDateTime.YYYY
						this.reserveStatusOfMonth.currentDateTime.MM = responce.data.currentDateTime.MM
						this.reserveStatusOfMonth.currentDateTime.DD = responce.data.currentDateTime.DD
						this.reserveStatusOfMonth.currentDateTime.hh = responce.data.currentDateTime.hh
						this.reserveStatusOfMonth.currentDateTime.mm = responce.data.currentDateTime.mm
					 
						// 現在のカレンダー表示
						this.reserveStatusOfMonth.calender.year = responce.data.currentDateTime.YYYY
						this.reserveStatusOfMonth.calender.month = responce.data.currentDateTime.MM
						// 表示するカレンダーの末尾日付
						this.reserveStatusOfMonth.calender.monthLastDate = 
							responce.data.calenderData.monthLastDate
						// 表示するカレンダーの月の初日の曜日
						this.reserveStatusOfMonth.calender.firstDayOfWeek = 
							responce.data.calenderData.firstDayOfWeek
						// 表示するカレンダーの月の末日の曜日
						this.reserveStatusOfMonth.calender.lastDayOfWeek = 
							responce.data.calenderData.lastDayOfWeek
						// 前月の第５週の表示日（初週に表示）
						this.reserveStatusOfMonth.calender.preMonthDates = 
							responce.data.calenderData.preMonthDates
						// 次月の第１週の表示日（初週に表示）
						this.reserveStatusOfMonth.calender.nextMonthDates = 
							responce.data.calenderData.nextMonthDates
						// 予約データ 全て
						this.reserveStatusOfMonth.listReserveDateWakuAll =
							responce.data.listReserveDateWakuAll
						// 予約データ　枠ごと１
						// （枠管理区分：日）
						// 登録人数の集計結果
						this.reserveStatusOfMonth.listReserveDate1 = 
							responce.data.listReserveDate1
						// 予約データ　枠ごと２
						// （枠管理区分：時間帯）
						// 登録人数の集計結果
						this.reserveStatusOfMonth.listReserveDate2 = 
							responce.data.listReserveDate2
						// 予約データ　枠ごと３
						// （枠管理区分：日）
						// 枠の集計結果
						this.reserveStatusOfMonth.listReserveDate3 = 
							responce.data.listReserveDate3
						// 予約データ　枠ごと４
						// （枠管理区分：時間帯）
						// 枠の集計結果
						this.reserveStatusOfMonth.listReserveDate4 = 
							responce.data.listReserveDate4

						// カレンダーに表示する日付配列の作成
						this.createDisplayDates()
						// カレンダー表示用に整形された予約結果配列の作成
						this.reserveStatusOfMonth.currentWaku = this.reserveStatusOfMonth.listWaku[0].waku
						this.createReserveData()

						// 前の月次の月の表示非表示判定
						this.updateFlagPreNextMonth()

						this.reserveStatusOfMonth.calender.isCuliculate = true

					} else if (responce.data.errorCode == ErrorCodes.ERRORCODE_CORRECTION) {

						// 前の月、次の月リンクを非表示にする
						this.reserveStatusOfMonth.calender.flagPreMonth = false
						this.reserveStatusOfMonth.calender.flagNextMonth = false

						this.onMasterErrorModalOpen(responce.data.errorMessagesList)

					}  else if (responce.data.errorCode == ErrorCodes.ERRORCODE_SIMPLEITEM
						|| responce.data.errorCode == ErrorCodes.ERRORCODE_SYSTEM
						|| responce.data.errorCode == ErrorCodes.ERRORCODE_DB) {
						// システム、DBエラー時
						this.onSystemErrorModalOpen()
					}

				}).catch(() => {
					// システムエラー時
					this.onSystemErrorModalOpen()
				}).finally(() => {
					UtilityConsoleLog.consoleLog('AdminReserveStatusCheck::firstDisplay End')
				})
			},
			// カレンダー更新
			updateCalender: function() {
				UtilityConsoleLog.consoleLog('AdminReserveStatusCheck::updateCalender Start')

				AdminReserveStatusCheck.ChangeCalender({
					token: this.$store.state.auth.token,
					ircd: this.$store.state.auth.ircd,
					calenderYear: this.reserveStatusOfMonth.calender.year,
					calenderMonth: this.reserveStatusOfMonth.calender.month
				}).then(({responce}) => {

					if (responce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {
						
						// 月毎予約状況欄
						// 現在時刻
						this.reserveStatusOfMonth.currentDateTime.YYYY = responce.data.currentDateTime.YYYY
						this.reserveStatusOfMonth.currentDateTime.MM = responce.data.currentDateTime.MM
						this.reserveStatusOfMonth.currentDateTime.DD = responce.data.currentDateTime.DD
						this.reserveStatusOfMonth.currentDateTime.hh = responce.data.currentDateTime.hh
						this.reserveStatusOfMonth.currentDateTime.mm = responce.data.currentDateTime.mm
					 
						// 表示するカレンダーの末尾日付
						this.reserveStatusOfMonth.calender.monthLastDate = 
							responce.data.calenderData.monthLastDate
						// 表示するカレンダーの月の初日の曜日
						this.reserveStatusOfMonth.calender.firstDayOfWeek = 
							responce.data.calenderData.firstDayOfWeek
						// 表示するカレンダーの月の末日の曜日
						this.reserveStatusOfMonth.calender.lastDayOfWeek = 
							responce.data.calenderData.lastDayOfWeek
						// 前月の第５週の表示日（初週に表示）
						this.reserveStatusOfMonth.calender.preMonthDates = 
							responce.data.calenderData.preMonthDates
						// 次月の第１週の表示日（初週に表示）
						this.reserveStatusOfMonth.calender.nextMonthDates = 
							responce.data.calenderData.nextMonthDates
						// 予約データ 全て
						this.reserveStatusOfMonth.listReserveDateWakuAll =
							responce.data.listReserveDateWakuAll
						// 予約データ　枠ごと１
						// （枠管理区分：日）
						// 登録人数の集計結果
						this.reserveStatusOfMonth.listReserveDate1 = 
							responce.data.listReserveDate1
						// 予約データ　枠ごと２
						// （枠管理区分：時間帯）
						// 登録人数の集計結果
						this.reserveStatusOfMonth.listReserveDate2 = 
							responce.data.listReserveDate2
						// 予約データ　枠ごと３
						// （枠管理区分：日）
						// 枠の集計結果
						this.reserveStatusOfMonth.listReserveDate3 = 
							responce.data.listReserveDate3
						// 予約データ　枠ごと４
						// （枠管理区分：時間帯）
						// 枠の集計結果
						this.reserveStatusOfMonth.listReserveDate4 = 
							responce.data.listReserveDate4

						// カレンダーに表示する日付配列の作成
						this.createDisplayDates()
						// カレンダー表示用に整形された予約結果配列の作成
						this.createReserveData()
						// 前の月次の月の表示非表示判定
						this.updateFlagPreNextMonth()

					} else if (responce.data.errorCode == ErrorCodes.ERRORCODE_SIMPLEITEM
						|| responce.data.errorCode == ErrorCodes.ERRORCODE_SYSTEM
						|| responce.data.errorCode == ErrorCodes.ERRORCODE_DB) {
						// システム、DBエラー時
						this.onSystemErrorModalOpen()
					}
				
				}).catch(() => {
					// システムエラー時
					this.onSystemErrorModalOpen()
				}).finally(() => {
					UtilityConsoleLog.consoleLog('AdminReserveStatusCheck::updateCalender End')
				})
			},
			// 枠プルダウンに変更イベントが発生した場合
			onChangeListWaku: function(){
				UtilityConsoleLog.consoleLog('AdminReserveStatusCheck::onChangeListWaku Start')
				this.createReserveData()
				UtilityConsoleLog.consoleLog('AdminReserveStatusCheck::onChangeListWaku End')
			},
			// 集計結果種別に変更イベントが発生した場合
			onChangeListShukeiShubetsu: function () {
				UtilityConsoleLog.consoleLog('AdminReserveStatusCheck::onChangeListShukeiShubetsu Start')
				this.createReserveData()
				UtilityConsoleLog.consoleLog('AdminReserveStatusCheck::onChangeListShukeiShubetsu End')
			},
			// 表示系--------------------------------------------------E
			// イベント系--------------------------------------------------S
			onSearch:function(){
				UtilityConsoleLog.consoleLog("AdminReserveStatusCheck::onSearch Start")

				AdminReserveStatusCheck.SearchSummaryResults({
					token: this.$store.state.auth.token,
					ircd: this.$store.state.auth.ircd,
					// 予約登録日
					crdyStYear:  this.reserveStatus.inputForm.crdyStYear,
					crdyStMonth: this.reserveStatus.inputForm.crdyStMonth,
					crdyStDate:  this.reserveStatus.inputForm.crdyStDate,
					crdyEdYear:  this.reserveStatus.inputForm.crdyEdYear,
					crdyEdMonth: this.reserveStatus.inputForm.crdyEdMonth,
					crdyEdDate:  this.reserveStatus.inputForm.crdyEdDate,
					// 予約更新日
					updyStYear:  this.reserveStatus.inputForm.updyStYear,
					updyStMonth: this.reserveStatus.inputForm.updyStMonth,
					updyStDate:  this.reserveStatus.inputForm.updyStDate,
					updyEdYear:  this.reserveStatus.inputForm.updyEdYear,
					updyEdMonth: this.reserveStatus.inputForm.updyEdMonth,
					updyEdDate:  this.reserveStatus.inputForm.updyEdDate,
					// 受診日
					ykdyStYear:  this.reserveStatus.inputForm.ykdyStYear,
					ykdyStMonth: this.reserveStatus.inputForm.ykdyStMonth,
					ykdyStDate:  this.reserveStatus.inputForm.ykdyStDate,
					ykdyEdYear:  this.reserveStatus.inputForm.ykdyEdYear,
					ykdyEdMonth: this.reserveStatus.inputForm.ykdyEdMonth,
					ykdyEdDate:  this.reserveStatus.inputForm.ykdyEdDate,
				}).then(({responce}) => {

					if (responce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {

						// 予約状況欄
						// 予約状況（枠ごとの集計結果）
						this.reserveStatus.listResultCountOfWaku = responce.data.listResultCountOfWaku

					} else if (responce.data.errorCode == ErrorCodes.ERRORCODE_INPUTCORRECTION
						|| responce.data.errorCode == ErrorCodes.ERRORCODE_CORRECTION) {

						this.onValidationErrorModalOpen(responce.data.errorMessagesList)

					} else if (responce.data.errorCode == ErrorCodes.ERRORCODE_SIMPLEITEM
						|| responce.data.errorCode == ErrorCodes.ERRORCODE_SYSTEM
						|| responce.data.errorCode == ErrorCodes.ERRORCODE_DB) {
						// システム、DBエラー時
						this.onSystemErrorModalOpen()
					}

				}).catch(() => {
					// システムエラー時
					this.onSystemErrorModalOpen()
				}).finally(() => {
					UtilityConsoleLog.consoleLog('AdminReserveStatusCheck::onSearch End')
				})
			},
			// 前の月を押下したとき
			onCalenderPreMonth: function () {

				UtilityConsoleLog.consoleLog("AdminReserveStatusCheck::onCalenderPreMonth Start")

				// 現在カレンダーで表示されている月の最初の日のDateオブジェクトを作成
				var dateCurrentMonth = new Date(
					this.reserveStatusOfMonth.calender.year, this.reserveStatusOfMonth.calender.month - 1, 1)
				// 前月の最初の日のDateオブジェクトを作成
				var datePreMonth = new Date(
					this.reserveStatusOfMonth.calender.year, this.reserveStatusOfMonth.calender.month - 1, 1)
				datePreMonth.setMonth(dateCurrentMonth.getMonth() - 1)
				// 表示するカレンダーの年、月を変更
				this.reserveStatusOfMonth.calender.year = datePreMonth.getFullYear()
				this.reserveStatusOfMonth.calender.month = datePreMonth.getMonth() + 1
				// カレンダーの更新
				this.updateCalender()
				// 前の月次の月の表示非表示判定
				this.updateFlagPreNextMonth()

				UtilityConsoleLog.consoleLog("AdminReserveStatusCheck::onCalenderPreMonth End")
			},
			// 次の月を押下したとき
			onCalenderNextMonth: function () {

				UtilityConsoleLog.consoleLog("AdminReserveStatusCheck::onCalenderNextMonth Start")

				// 現在カレンダーで表示されている月の最初の日のDateオブジェクトを作成
				var dateCurrentMonth = new Date(
					this.reserveStatusOfMonth.calender.year,
					this.reserveStatusOfMonth.calender.month - 1, 1)
				// 次月の最初の日のDateオブジェクトを作成
				// dateCurrentMonth.getMonth()の値が11つまり12月の時は
				// +1されると次年度の1月値が0になる
				var dateNextMonth = new Date(
					this.reserveStatusOfMonth.calender.year,
					this.reserveStatusOfMonth.calender.month - 1, 1)
				dateNextMonth.setMonth(dateCurrentMonth.getMonth() + 1)
				// 表示するカレンダーの年、月を変更
				this.reserveStatusOfMonth.calender.year = dateNextMonth.getFullYear()
				this.reserveStatusOfMonth.calender.month = dateNextMonth.getMonth() + 1
				// カレンダーの更新
				this.updateCalender()
				// 前の月次の月の表示非表示判定
				this.updateFlagPreNextMonth()

				UtilityConsoleLog.consoleLog("AdminReserveStatusCheck::onCalenderNextMonth End")
			},
			// 前の月次の月の表示非表示判定
			updateFlagPreNextMonth: function () {

				UtilityConsoleLog.consoleLog("AdminReserveStatusCheck::updateFlagPreNextMonth Start")

				// 休業日マスタの最小日付の日付オブジェクト
				var dateMinCalm = new Date(
					this.reserveStatusOfMonth.calmDate.minDateYear,
					this.reserveStatusOfMonth.calmDate.minDateMonth - 1,
					this.reserveStatusOfMonth.calmDate.minDateDate)

				// 休業日マスタの最大日付の日付オブジェクト
				var dateMaxCalm = new Date(
					this.reserveStatusOfMonth.calmDate.maxDateYear,
					this.reserveStatusOfMonth.calmDate.maxDateMonth - 1,
					this.reserveStatusOfMonth.calmDate.maxDateDate)

				// 現在カレンダーで表示されている月の日付オブジェクトを作成
				var dateCurrent = new Date(
					this.reserveStatusOfMonth.calender.year,
					this.reserveStatusOfMonth.calender.month - 1, 1)

				// 現在カレンダーで表示されている月の
				// 前月の最初の日のDateオブジェクトを作成
				var datePreFirst = new Date(
					this.reserveStatusOfMonth.calender.year,
					this.reserveStatusOfMonth.calender.month - 1, 1)
				datePreFirst.setMonth(dateCurrent.getMonth() - 1)

				// 現在カレンダーで表示されている月の
				// 次月の最後の日（次々月の最初の日の一日前）のDateオブジェクトを作成
				var dateNextLast = new Date(
						this.reserveStatusOfMonth.calender.year,
						this.reserveStatusOfMonth.calender.month - 1, 1)
				dateNextLast.setMonth(dateCurrent.getMonth() + 2)
				dateNextLast.setDate(dateNextLast.getDate() - 1)

				// 前の月フラグの表示非表示
				// true:  休業日マスタの最小日付 <= 前月の最初の日
				if (dateMinCalm.getTime() <= datePreFirst.getTime()){
					this.reserveStatusOfMonth.calender.flagPreMonth = true
				}
				else {
					this.reserveStatusOfMonth.calender.flagPreMonth = false
				}

				// 次の月フラグの表示非表示
				// true:  次月の最後の日 <= 休業日マスタの最大日付
				if (dateNextLast.getTime() <= dateMaxCalm.getTime()) {
					this.reserveStatusOfMonth.calender.flagNextMonth = true
				}
				else {
					this.reserveStatusOfMonth.calender.flagNextMonth = false
				}

				UtilityConsoleLog.consoleLog("AdminReserveStatusCheck::updateFlagPreNextMonth End")
			},
			// イベント系--------------------------------------------------E
			// その他--------------------------------------------------S
			// カレンダーに表示する日付配列の作成
			createDisplayDates: function () {
				
				UtilityConsoleLog.consoleLog('AdminReserveStatusCheck::createDisplayDates Start');

				// カレンダーに表示する日付配列の行
				// （何週持ってるか）の添え字配列を作成
				var weekLength = this.checkNumWeeksOfDisplayDates()

				this.reserveStatusOfMonth.calender.displayDatesWeekIndexes = []
				for (var i = 0; i < weekLength; i++) {
					this.reserveStatusOfMonth.calender.displayDatesWeekIndexes.push(i)
				}

				// カレンダーに表示する日付配列の初期化
				this.reserveStatusOfMonth.calender.displayDates = []
				// 作成用の配列
				var tempDisplayDates = []
				// 前月の最大値
				var indexMaxPreMonth = this.reserveStatusOfMonth.calender.preMonthDates.length
				// 当月の最大値
				var indexMaxCurrentMonth = this.reserveStatusOfMonth.calender.monthLastDate
				// 来月の最大値
				var indexMaxNextMonth = this.reserveStatusOfMonth.calender.nextMonthDates.length

				// 前月分の日付配列を作成--------------------------------S
				var indexStart = 0
				var indexMax = indexMaxPreMonth

				for (var i = indexStart; i < indexMax; i++) {
					tempDisplayDates.push(this.reserveStatusOfMonth.calender.preMonthDates[i])
				}
				// 前月分の日付配列を作成--------------------------------E
				// 当月分の日付配列を作成--------------------------------S
				indexStart = indexMaxPreMonth
				indexMax = indexMaxPreMonth + indexMaxCurrentMonth;
				// 日付配列の値（1～31）
				var valueOfCurrentDate = 1

				for (var i = indexStart; i < indexMax; i++) {
					tempDisplayDates.push(valueOfCurrentDate)
					valueOfCurrentDate++
				}
				// 当月分の日付配列を作成--------------------------------E
				// 次月分の日付配列を作成--------------------------------S
				var indexStart = indexMaxPreMonth + indexMaxCurrentMonth
				var indexMax = indexMaxPreMonth + indexMaxCurrentMonth + indexMaxNextMonth
				// 次月分の日付配列インデックス
				var indexNextMonthDates = 0

				// 次月用の配列の値
				for (var i = indexStart; i < indexMax; i++) {
					tempDisplayDates.push(this.reserveStatusOfMonth.calender.nextMonthDates[indexNextMonthDates])
					indexNextMonthDates++
				}

				// 次月分の日付配列を作成--------------------------------E
				// カレンダーに表示する日付配列に代入
				this.reserveStatusOfMonth.calender.displayDates = tempDisplayDates

				UtilityConsoleLog.consoleLog('AdminReserveStatusCheck::createDisplayDates End');
			},
			// カレンダーに表示する日付配列が何週間分の情報を持つべきか返す
			checkNumWeeksOfDisplayDates: function () {

				UtilityConsoleLog.consoleLog('AdminReserveStatusCheck::checkNumWeeksOfDisplayDates Start');

				var numDate = this.reserveStatusOfMonth.calender.firstDayOfWeek
				 + this.reserveStatusOfMonth.calender.monthLastDate

				var numWeek = Math.floor((numDate / 7))
				
				if(numDate % 7 != 0) {
					numWeek += 1
				}

				UtilityConsoleLog.consoleLog('AdminReserveStatusCheck::checkNumWeeksOfDisplayDates End');

				return numWeek
			},
			// カレンダー表示用に整形された予約結果配列の作成
			createReserveData: function() {

				UtilityConsoleLog.consoleLog('AdminReserveStatusCheck::createReserveData Start')

				// カレンダー表示用の予約結果配列の初期化
				this.reserveStatusOfMonth.calender.reserveData = []
				// 作成用の配列
				var tempReserveData = []

				// 前月の最大値
				var indexMaxPreMonth = this.reserveStatusOfMonth.calender.preMonthDates.length
				// 当月の最大値
				var indexMaxCurrentMonth = this.reserveStatusOfMonth.calender.monthLastDate
				// 来月の最大値
				var indexMaxNextMonth = this.reserveStatusOfMonth.calender.nextMonthDates.length

				// 前月分の日付配列を作成
				var indexStart = 0
				var indexMax = indexMaxPreMonth

				for (var i = indexStart; i < indexMax; i++) {
					tempReserveData.push(this.createReserveDataOfDate(
						0,i
					))
				}

				// 当月分の日付配列を作成
				indexStart = indexMaxPreMonth
				indexMax = indexMaxPreMonth + indexMaxCurrentMonth;

				for (var i = indexStart; i < indexMax; i++) {
					tempReserveData.push(this.createReserveDataOfDate(
						1,i
					))
				}

				// 次月分の日付配列を作成
				var indexStart = indexMaxPreMonth + indexMaxCurrentMonth
				var indexMax = indexMaxPreMonth + indexMaxCurrentMonth + indexMaxNextMonth

				// 次月用の配列の値
				for (var i = indexStart; i < indexMax; i++) {
					tempReserveData.push(this.createReserveDataOfDate(
						2,i
					))
				}

				// カレンダーに表示する日付配列に代入
				this.reserveStatusOfMonth.calender.reserveData = tempReserveData

				UtilityConsoleLog.consoleLog('AdminReserveStatusCheck::createReserveData End')
			},
			// カレンダー表示用の一日分の予約結果配列の作成
			createReserveDataOfDate: function(
				in_flagPreCurrentNextMonth,in_indexDisplayDates) {

				var result = null

				// どの集計結果種別を指定しているか
				var tempShukeiShubetsu = this.reserveStatusOfMonth.currentShukeiShubetsu

				// 選択された枠のオブジェクト(waku:枠、krkb:枠管理区分)
				var tempWakuObject = this.getCurrentWakuObject(this.reserveStatusOfMonth.currentWaku)

				if ('0000' == tempWakuObject.waku){
					// 「全て」選択のとき
					result = this.createReserveDataAll(
						in_flagPreCurrentNextMonth,in_indexDisplayDates)
				} else if('1' == tempWakuObject.krkb){

          if('0' == tempShukeiShubetsu) {
					  // 予約データ（枠管理区分：日）（登録人数の集計結果）
					  result = this.createReserveData1(
					  	in_flagPreCurrentNextMonth,in_indexDisplayDates)
					} else {
						// 予約データ（枠管理区分：日）（枠の集計結果）
					  result = this.createReserveData3(
					  	in_flagPreCurrentNextMonth,in_indexDisplayDates)
					}
				} else {
					if('0' == tempShukeiShubetsu) {
					  // 予約データ（枠管理区分：時間帯）（登録人数の集計結果）
					  result = this.createReserveData2(
						  in_flagPreCurrentNextMonth,in_indexDisplayDates)
					} else {
						// 予約データ（枠管理区分：時間帯）（枠の集計結果）
					  result = this.createReserveData4(
						  in_flagPreCurrentNextMonth,in_indexDisplayDates)
					}
				}

				return result
			},
			// 全て選択時の一日ごとの予約情報の作成
			createReserveDataAll: function(in_flagPreCurrentNextMonth,in_indexDisplayDates){

				var resultObject = null
				var tempSumCountOfDate = 0

				// 現在の日付
				var tempDate = this.reserveStatusOfMonth.calender.displayDates[in_indexDisplayDates]
				// 現在の日付（文字列）
				var tempStrDate = this.convertDateYYYYMMDD(
					this.reserveStatusOfMonth.calender.year,
					this.reserveStatusOfMonth.calender.month,
					tempDate
				)

				if (in_flagPreCurrentNextMonth == 0
						|| in_flagPreCurrentNextMonth == 2) {

						resultObject = this.createFormatReserveData(
							false,0,[]
						)
				} else {

					var tempReserveDataAll = this.reserveStatusOfMonth.listReserveDateWakuAll.filter((item)=>{
						return item.reserveDate == tempStrDate
					})

					for(var i=0;i<tempReserveDataAll.length;i++){

						tempSumCountOfDate += tempReserveDataAll[i].sumCount
					}
					
					resultObject = this.createFormatReserveData(
						true,tempSumCountOfDate,[]
					)
				}

				return resultObject
			},
			// 予約データ（枠管理区分：日）（登録人数の集計結果）の作成
			createReserveData1: function(in_flagPreCurrentNextMonth,in_indexDisplayDates){

				var resultObject = null

				// 現在の日付
				var tempDate = this.reserveStatusOfMonth.calender.displayDates[in_indexDisplayDates]
				// 現在の日付（文字列）
				var tempStrDate = this.convertDateYYYYMMDD(
					this.reserveStatusOfMonth.calender.year,
					this.reserveStatusOfMonth.calender.month,
					tempDate
				)

				if (in_flagPreCurrentNextMonth == 0
						|| in_flagPreCurrentNextMonth == 2) {

						resultObject = this.createFormatReserveData(
							false,0,[]
						)
				} else {

					var tempReserveDataOfDate = this.reserveStatusOfMonth.listReserveDate1.filter((item)=>{
						return item.waku == this.reserveStatusOfMonth.currentWaku && item.reserveDate == tempStrDate
					})

					if(tempReserveDataOfDate.length == 1) {
						resultObject = this.createFormatReserveData(
							true,tempReserveDataOfDate[0].sumCount,[]
						)
					} else{
						resultObject = this.createFormatReserveData(
							true,0,[]
						)
					}
				}

				return resultObject
			},
			// 予約データ（枠管理区分：時間帯）（登録人数の集計結果）の作成
			createReserveData2: function(in_flagPreCurrentNextMonth,in_indexDisplayDates) {

				var resultObject = null
				var resultCountArray = []
				var tempSumCountOfDate = 0

				// 現在の日付
				var tempDate = this.reserveStatusOfMonth.calender.displayDates[in_indexDisplayDates]
				// 現在の日付（文字列）
				var tempStrDate = this.convertDateYYYYMMDD(
					this.reserveStatusOfMonth.calender.year,
					this.reserveStatusOfMonth.calender.month,
					tempDate
				)

				if (in_flagPreCurrentNextMonth == 0
						|| in_flagPreCurrentNextMonth == 2) {
						resultObject = this.createFormatReserveData(
							false,0,[]
						)
				} else {

					var tempReserveDataOfTime = this.reserveStatusOfMonth.listReserveDate2.filter((item)=>{
						return item.waku == this.reserveStatusOfMonth.currentWaku && item.reserveDate == tempStrDate
					})

					for(var i=0;i<tempReserveDataOfTime.length;i++){

						tempSumCountOfDate += tempReserveDataOfTime[i].sumCount

						resultCountArray.push({
							sthm: tempReserveDataOfTime[i].sthm,
							sumCount: tempReserveDataOfTime[i].sumCount
						})
					}
					
					resultObject = this.createFormatReserveData(
						true,tempSumCountOfDate,resultCountArray
					)
				}

				return resultObject
			},
			// 予約データ（枠管理区分：日）（枠の集計結果）の作成
			createReserveData3: function(in_flagPreCurrentNextMonth,in_indexDisplayDates){

				var resultObject = null

				// 現在の日付
				var tempDate = this.reserveStatusOfMonth.calender.displayDates[in_indexDisplayDates]
				// 現在の日付（文字列）
				var tempStrDate = this.convertDateYYYYMMDD(
					this.reserveStatusOfMonth.calender.year,
					this.reserveStatusOfMonth.calender.month,
					tempDate
				)

				if (in_flagPreCurrentNextMonth == 0
						|| in_flagPreCurrentNextMonth == 2) {

						resultObject = this.createFormatReserveData(
							false,0,[]
						)
				} else {

					var tempReserveDataOfDate = this.reserveStatusOfMonth.listReserveDate3.filter((item)=>{
						return item.waku == this.reserveStatusOfMonth.currentWaku && item.reserveDate == tempStrDate
					})

					if(tempReserveDataOfDate.length == 1) {
						resultObject = this.createFormatReserveData(
							true,tempReserveDataOfDate[0].sumCount,[]
						)
					} else{
						resultObject = this.createFormatReserveData(
							true,0,[]
						)
					}
				}

				return resultObject
			},
			// 予約データ（枠管理区分：時間帯）（登録人数の集計結果）の作成
			createReserveData4: function(in_flagPreCurrentNextMonth,in_indexDisplayDates) {

				var resultObject = null
				var resultCountArray = []
				var tempSumCountOfDate = 0

				// 現在の日付
				var tempDate = this.reserveStatusOfMonth.calender.displayDates[in_indexDisplayDates]
				// 現在の日付（文字列）
				var tempStrDate = this.convertDateYYYYMMDD(
					this.reserveStatusOfMonth.calender.year,
					this.reserveStatusOfMonth.calender.month,
					tempDate
				)

				if (in_flagPreCurrentNextMonth == 0
						|| in_flagPreCurrentNextMonth == 2) {
						resultObject = this.createFormatReserveData(
							false,0,[]
						)
				} else {

					var tempReserveDataOfTime = this.reserveStatusOfMonth.listReserveDate4.filter((item)=>{
						return item.waku == this.reserveStatusOfMonth.currentWaku && item.reserveDate == tempStrDate
					})

					for(var i=0;i<tempReserveDataOfTime.length;i++){

						tempSumCountOfDate += tempReserveDataOfTime[i].sumCount

						resultCountArray.push({
							sthm: tempReserveDataOfTime[i].sthm,
							sumCount: tempReserveDataOfTime[i].sumCount
						})
					}
					
					resultObject = this.createFormatReserveData(
						true,tempSumCountOfDate,resultCountArray
					)
				}

				return resultObject
			},
			// 一日ごとの予約情報のオブジェクトのフォーマット
			createFormatReserveData: function(
				in_isDisplay,in_sumCountOfDate,in_countArray
			){
				return {
					isDisplay: in_isDisplay,
					sumCountOfDate: in_sumCountOfDate,
					countArray: in_countArray
				}
			},
			// YYYY/MM/DDの形式に整形する
			convertDateYYYYMMDD: function (year, month, dd) {

				var tempYear = String(year)
				var tempMonth = String(month)
				var tempDate = String(dd)

				var tempYYYYMMDD = ''

				if (tempMonth.length == 1) {
					tempMonth = '0' + tempMonth
				}

				if (tempDate.length == 1) {
					tempDate = '0' + tempDate
				}

				tempYYYYMMDD = tempYear + '/' + tempMonth + '/' + tempDate

				return tempYYYYMMDD
			},
			// 現在の指定されている枠管理区分の取得
			// 1: 枠管理区分　日
			// 2: 枠管理区分　時間
			getCurrentKrkb: function(){

				var resultKrkb = '0'
				var tempWakuObject = this.getCurrentWakuObject(this.reserveStatusOfMonth.currentWaku)

				if(tempWakuObject != null) {
					resultKrkb = tempWakuObject.krkb
				}

				return resultKrkb
			},
			// 現在選択している枠オブジェクトの取得
			getCurrentWakuObject: function(in_waku){

				var resultObject = null

				var tempArray = this.reserveStatusOfMonth.listWaku.filter((item)=>{
					return item.waku == in_waku
				})
				
				if(tempArray.length == 1){
					resultObject = tempArray[0]
				}

				return resultObject
			},
			// ラジオボタン用　for、name、idに名前割り当て
			getBindName: function(in_for,index){
				return in_for + String(index)
			},
			// バリデーションエラーモーダルとしてエラーモーダルを開く
			onValidationErrorModalOpen: function (errorMessages) {

				UtilityConsoleLog.consoleLog('AdminReserveStatusCheck::onValidationErrorModalOpen Start')

				var tempMessages = [
					'入力エラーです。',
					'以下の内容をもう一度ご確認ください'
				]
				
				errorMessages.forEach((item)=>{
					tempMessages.push(item)
				})

				this.modal.validationError.messages = tempMessages
				this.modalOpen('validationError')

				UtilityConsoleLog.consoleLog('AdminReserveStatusCheck::onValidationErrorModalOpen End')
			},
			// バリデーションエラーモーダルを閉じる
			onValidationErrorModalClose: function () {
				UtilityConsoleLog.consoleLog('AdminReserveStatusCheck::onValidationErrorModalClose Start')

				this.modalClose('validationError')

				UtilityConsoleLog.consoleLog('AdminReserveStatusCheck::onValidationErrorModalClose End')
			},
			// マスタエラーモーダルとしてエラーモーダルを開く
			onMasterErrorModalOpen: function (errorMessages) {

				UtilityConsoleLog.consoleLog('AdminReserveStatusCheck::onMasterErrorModalOpen Start')

				var tempMessages = [
					'マスタエラーです。',
					'以下の内容をもう一度ご確認ください'
				]
				
				errorMessages.forEach((item)=>{
					tempMessages.push(item)
				})

				this.modal.masterError.messages = tempMessages
				this.modalOpen('masterError')

				UtilityConsoleLog.consoleLog('AdminReserveStatusCheck::onMasterErrorModalOpen End')
			},
			// マスタエラーモーダルを閉じる
			onMasterErrorModalClose: function () {
				UtilityConsoleLog.consoleLog('AdminReserveStatusCheck::onMasterErrorModalClose Start')

				this.modalClose('masterError')

				UtilityConsoleLog.consoleLog('AdminReserveStatusCheck::onMasterErrorModalClose End')
			},
			// システムエラーモーダルとしてエラーモーダルを開く
			onSystemErrorModalOpen: function () {

				UtilityConsoleLog.consoleLog('AdminReserveStatusCheck::onSystemErrorModalOpen Start')

				this.modalOpen('systemError')

				UtilityConsoleLog.consoleLog('AdminReserveStatusCheck::onSystemErrorModalOpen End')
			},
			// システムエラーモーダルを閉じる
			onSystemErrorModalClose: function () {
				UtilityConsoleLog.consoleLog('AdminReserveStatusCheck::onSystemErrorModalClose Start')

				this.modalClose('systemError')
				this.$router.push("/AdminLogin")

				UtilityConsoleLog.consoleLog('AdminReserveStatusCheck::onSystemErrorModalClose End')
			},
			// モーダルウィンドウを開く
			modalOpen: function (modalName) {

				UtilityConsoleLog.consoleLog('AdminReserveStatusCheck::modalOpen Start')

				// すべてのモーダルを閉じる
				this.allModalClose()

				this.modal[modalName].isShow = true

				UtilityConsoleLog.consoleLog('AdminReserveStatusCheck::modalOpen End')
			},
			// モーダルウィンドウを閉じる
			modalClose: function (modalName) {

				UtilityConsoleLog.consoleLog('AdminReserveStatusCheck::modalClose Start')

				this.modal[modalName].isShow = false

				UtilityConsoleLog.consoleLog('AdminReserveStatusCheck::modalClose End')
			},
			// 全てのモーダルを閉じる
			allModalClose: function() {  
				for(var key in this.modal) {
					this.modal[key].isShow = false
				}
			},
			// その他--------------------------------------------------E
		}
	}
	</script>



// WEBPACK FOOTER //
// src/components/Admin/ReserveStatusCheck/AdminReserveStatusCheck.vue